import React from "react";

export const schema = {
        title: "",
        description: "",
        type: "object",
        //required: ["title"],
        properties: {
            upper_chest: {type: "integer", title: "", default: ""},
            lower_chest: {type: "integer", title: "", default: ""},
            abdomen: {type: "integer", title: "", default: ""},
            waist: {type: "integer", title: "", default: ""},
            hip: {type: "integer", title: "", default: ""},
            thigh_right: {type: "integer", title: "", default: ""},
            thigh_left: {type: "integer", title: "", default: ""},
            calf_right: {type: "integer", title: "", default: ""},
            calf_left: {type: "integer", title: "", default: ""},
            arm_right: {type: "integer", title: "", default: ""},
            arm_left: {type: "integer", title: "", default: ""},
            arm_flexed_right: {type: "integer", title: "", default: ""},
            arm_flexed_left: {type: "integer", title: "", default: ""},
            forearm_right: {type: "integer", title: "", default: ""},
            forearm_left: {type: "integer", title: "", default: ""},
            neck: {type: "integer", title: "", default: ""},
            shoulder: {type: "integer", title: "", default: ""},
        }
}

export const uiSchema = {
    upper_chest: {
        "ui:widget": "updown",
        "ui:title": "1. Upper Chest Measurement", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Around upper lats, below armpits",
        "ui:placeholder": "0"
    },
    lower_chest: {
        "ui:widget": "updown",
        "ui:title": "2. Lower Chest", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "At nipple level",
        "ui:placeholder": "0"
    },
    abdomen: {
        "ui:widget": "updown",
        "ui:title": "3. Abdomen", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Level of umbilicus",
        "ui:placeholder": "0"
    },
    waist: {
        "ui:widget": "updown",
        "ui:title": "4. Waist", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Narrowest part of waist, above umbilicus and below xiphoid process",
        "ui:placeholder": "0"
    },
    hip: {
        "ui:widget": "updown",
        "ui:title": "5. Hip", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Maximal girth of hip, or buttocks above gluteal fold",
        "ui:placeholder": "0"
    },
    thigh_right: {
        "ui:widget": "updown",
        "ui:title": "6. Thigh (Right)", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Maximal girth of thigh, below gluteal fold, legs slightly apart",
        "ui:placeholder": "0"
    },
    thigh_left: {
        "ui:widget": "updown",
        "ui:title": "7. Thigh (Left)", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Maximal girth of thigh, below gluteal fold, legs slightly apart",
        "ui:placeholder": "0"
    },
    calf_right: {
        "ui:widget": "updown",
        "ui:title": "8. Calf (Right)", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Maximum girth between knee and ankle joint",
        "ui:placeholder": "0"
    },
    calf_left: {
        "ui:widget": "updown",
        "ui:title": "9. Calf (Left)", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Maximum girth between knee and ankle joint",
        "ui:placeholder": "0"
    },
    arm_right: {
        "ui:widget": "updown",
        "ui:title": "10. Arm (Right)", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Arm in anatomical position, midway between acromion and olecranon processes",
        "ui:placeholder": "0"
    },
    arm_left: {
        "ui:widget": "updown",
        "ui:title": "11. Arm (Left)", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Arm in anatomical position, midway between acromion and olecranon processes",
        "ui:placeholder": "0"
    },
    arm_flexed_right: {
        "ui:widget": "updown",
        "ui:title": "12. Arm Flexed (Right)", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Maximally contracts the biceps muscle, and the largest circumference is measured",
        "ui:placeholder": "0"
    },
    arm_flexed_left: {
        "ui:widget": "updown",
        "ui:title": "13. Arm Flexed (Left)", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Maximally contracts the biceps muscle, and the largest circumference is measured",
        "ui:placeholder": "0"
    },
    forearm_right: {
        "ui:widget": "updown",
        "ui:title": "14. Forearm (Right)", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Maximum girth of forearm, arm hanging downward and slightly away from trunk palms facing forward",
        "ui:placeholder": "0"
    },
    forearm_left: {
        "ui:widget": "updown",
        "ui:title": "15. Forearm (Left)", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Maximum girth of forearm, arm hanging downward and slightly away from trunk palms facing forward",
        "ui:placeholder": "0"
    },
    neck: {
        "ui:widget": "updown",
        "ui:title": "16. Neck", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Largest girth below Adam's apple, perpendicular to axis of neck",
        "ui:placeholder": "0"
    },
    shoulder: {
        "ui:widget": "updown",
        "ui:title": "17. Shoulder", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Maximum girth around both deltoid muscles and upper torso",
        "ui:placeholder": "0"
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/schema/Girth.js